var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4408_20517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 4.85538C13.8744 4.85538 4.85537 13.8744 4.85537 25C4.85537 36.1256 13.8744 45.1446 25 45.1446C36.1256 45.1446 45.1446 36.1256 45.1446 25C45.1446 13.8744 36.1256 4.85538 25 4.85538ZM0.378784 25C0.378784 11.4021 11.4021 0.378792 25 0.378792C38.5979 0.378792 49.6212 11.4021 49.6212 25C49.6212 38.5979 38.5979 49.6212 25 49.6212C11.4021 49.6212 0.378784 38.5979 0.378784 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85537 25C4.85537 13.8744 13.8744 4.85538 25 4.85538C36.1256 4.85538 45.1446 13.8744 45.1446 25C45.1446 36.1256 36.1256 45.1446 25 45.1446C13.8744 45.1446 4.85537 36.1256 4.85537 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3038 17.1258C38.9005 17.7225 38.9005 18.69 38.3038 19.2866L21.4966 36.0939C20.8999 36.6905 19.9325 36.6905 19.3358 36.0939L11.6962 28.4542C11.0995 27.8575 11.0995 26.8901 11.6962 26.2934C12.2929 25.6967 13.2603 25.6967 13.857 26.2934L20.4162 32.8526L36.143 17.1258C36.7397 16.5291 37.7071 16.5291 38.3038 17.1258Z",
    fill: "#3a614b"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4408_20517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.0cca678541782a1c0997c9bbb2644496.svg";
export { ForwardRef as ReactComponent };